import { jsPDF } from 'jspdf';

// Mobile-safe download: blob URL + anchor attached to the DOM (data-URLs and
// detached anchors are blocked by mobile Chrome/Safari).
export const saveBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { a.remove(); URL.revokeObjectURL(url); }, 5000);
};

// Renders the live garage diagram SVG (data-testid="garage-diagram-svg") to a
// white-background canvas at 2x, with print-friendly styles inlined.
export const renderDiagramCanvas = () => new Promise((resolve) => {
  const svg = document.querySelector('[data-testid="garage-diagram-svg"]');
  if (!svg) { resolve(null); return; }
  const clone = svg.cloneNode(true);
  const style = document.createElementNS('http://www.w3.org/2000/svg', 'style');
  style.textContent = [
    '.dd-room-line{stroke:#2A2D33;stroke-width:1.6;fill:none}',
    '.dd-grid{stroke:#B9BDC4;stroke-width:1;fill:none}',
    '.dd-dim{stroke:#C8102E;fill:#C8102E}',
    '.dd-dim line{stroke-width:2}',
    '.dd-dim polygon{stroke:none}',
    '.dd-dim text{stroke:none;fill:#C8102E;font-size:20px;font-weight:600;font-family:Arial,sans-serif}',
    '.dd-dim .dd-dim-hit{display:none}',
    '.dd-dim-value rect{fill:#ffffff;stroke:#C8102E;stroke-width:1}',
    '.dd-dim-value text{fill:#C8102E;font-size:14px;font-weight:700;font-family:Arial,sans-serif}',
    '.dd-caption{fill:#C8102E;font-size:17px;font-weight:600;font-family:Arial,sans-serif;letter-spacing:1px}',
  ].join('\n');
  clone.insertBefore(style, clone.firstChild);
  const vb = svg.viewBox && svg.viewBox.baseVal ? svg.viewBox.baseVal : { width: 1180, height: 735 };
  const bg = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  bg.setAttribute('x', '0'); bg.setAttribute('y', '0');
  bg.setAttribute('width', String(vb.width)); bg.setAttribute('height', String(vb.height));
  bg.setAttribute('fill', '#ffffff');
  clone.insertBefore(bg, style);
  const str = new XMLSerializer().serializeToString(clone);
  const url = URL.createObjectURL(new Blob([str], { type: 'image/svg+xml;charset=utf-8' }));
  const img = new Image();
  img.onload = () => {
    const scale = 2;
    const canvas = document.createElement('canvas');
    canvas.width = vb.width * scale;
    canvas.height = vb.height * scale;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    URL.revokeObjectURL(url);
    resolve(canvas);
  };
  img.onerror = () => { URL.revokeObjectURL(url); resolve(null); };
  img.src = url;
});

export const downloadDiagramPNG = async (filename = 'configuratie-porti-garaj.png') => {
  const canvas = await renderDiagramCanvas();
  if (!canvas) return;
  canvas.toBlob((blob) => { if (blob) saveBlob(blob, filename); }, 'image/png');
};

export const downloadDiagramPDF = async ({ title, rows = [], filename = 'configuratie-porti-garaj.pdf' }) => {
  const canvas = await renderDiagramCanvas();
  if (!canvas) return;
  const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const margin = 14;
  pdf.setFontSize(13);
  pdf.setTextColor(200, 16, 46);
  pdf.text(title, margin, margin);
  const imgY = margin + 8;
  const ratio = canvas.height / canvas.width;
  let imgW = pageW - margin * 2;
  let imgH = imgW * ratio;
  const maxH = pageH - imgY - margin - 16;
  if (imgH > maxH) { imgH = maxH; imgW = imgH / ratio; }
  pdf.addImage(canvas.toDataURL('image/jpeg', 0.95), 'JPEG', (pageW - imgW) / 2, imgY, imgW, imgH);
  if (rows.length) {
    pdf.setFontSize(11);
    pdf.setTextColor(42, 45, 51);
    const half = Math.ceil(rows.length / 2);
    pdf.text(rows.slice(0, half).join('        '), margin, imgY + imgH + 9);
    if (rows.length > half) pdf.text(rows.slice(half).join('        '), margin, imgY + imgH + 16);
  }
  pdf.save(filename);
};
